import * as React from "react"

const SvgComponent = (props) => (
    <svg width={512} height={512}
        viewBox={`0 0 512 512`}
         {...props}>
        <path fill="#F72585" d="M8 0 0 8v496l8 8h496l8-8V8l-8-8zm488 496H16V16h480zM233 340l7 4h224v-16H244l-93-140-7-4H48v16h92zm7-156h224v16H240z" />
    </svg>
)

export default SvgComponent
